var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.vueAppClasses,attrs:{"id":"app"}},[_c('router-view',{on:{"setAppClasses":_vm.setAppClasses}}),_c('custom-event',{ref:"event",attrs:{"event-data":_vm.newEvents[0]},on:{"seen":function($event){return _vm.showEvent(true)}}}),_c('custom-context-menu',{ref:"contextMenu"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }